import {
    get,
    post,
    put
} from '../configApi'

//quiz
export async function getOverviewReportCourse(params) {
    return await get(`/report/course/header`, params)
}

export async function getLiveReport(params) {
    return await post(`/report/student/livehistory`, params)
}
export async function getUserOndemand(params) {
    return await get(`/report/student/ondemand`, params)
}
export async function getHistoryReport(params) {
    return await post(`/report/student/historyonlinelive`, params)
}
export async function getExamReport(params) {
    return await get(`/report/exam/listallscore`, params)
}
export async function getExportExamReport(params) {
    return await get(`/report/exam/listallscore/export`, params)
}
export async function getExamCourse(params) {
    return await get(`/exam/list/coursereport`, params)
}
export async function getLearnerSuccessCertificate(params) {
    return await get(`/report/course/liststudentforsendmail`, params)
}
export async function sendCertificateToLearner(body) {
    return await post(`/sendmail/sendcertificate/array`, body)
}
export async function getExamReportDetail(params) {
    return await get(`/report/exam/top`, params)
}
export async function getExamFaceDetection(params) {
    return await get(`/exam/face`, params)
}
export async function updateFaceDetection(body) {
    return await put(`/exam/updatefaceticket`, body)
}

